// extracted by mini-css-extract-plugin
module.exports = {"articleTab":"style_articleTab__a_U3B","navLink":"style_navLink__q3Ljn","active":"style_active__Pes7v","icon":"style_icon__Da1TE"};